module.exports = __webpack_public_path__ + "static/media/log-out.ce231ada.png";